import React from 'react';
import styles from './MetricCard.module.css';

export interface MetricCardProps {
  icon: React.ReactNode;
  label: string;
  value: string | number;
  subtitle?: string;
  color?: 'gray' | 'green' | 'red' | 'yellow';
}

const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  label,
  value,
  subtitle,
  color = 'gray',
}): React.ReactElement => {
  return (
    <div className={`${styles.card} ${styles[color]}`} data-testid="metric-card">
      <div className={styles.content}>
        <p className={styles.label}>{label}</p>
        <p className={styles.value}>{value}</p>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </div>
  );
};

export default MetricCard;
